import { render, staticRenderFns } from "./StructureAction.vue?vue&type=template&id=21cb4cd3"
import script from "./StructureAction.vue?vue&type=script&lang=js"
export * from "./StructureAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports